module.exports = __webpack_public_path__ + "static/media/3.913cd780.png";